













































































import {
  Component, Mixins, Prop, Watch, Ref,
} from 'vue-property-decorator';
import InitLocation from 'src/mixin/initLocation';
import { getAllIndustry, updateBasicInfo } from 'service/api';
import { ElForm } from 'element-ui/types/form.d';

interface IndustryItem {
  id: string;
  name: string;
}
interface IndustryRes {
  state: boolean;
  data: {
    rows: IndustryItem[];
  };
}
interface Info {
  userName: string;
  garden: string;
  province: string;
  city: string;
  downtown: string;
  industry: string[];
}

const industry: string[] = [];

@Component
export default class PersonalInfo extends Mixins(InitLocation) {
  @Ref('form') readonly form!: ElForm;

  @Prop(Object) value!: Info;

  @Watch('value')
  onValueChange(val: Info) {
    this.personalInfo = {
      ...val,
    };
  }

  personalInfo = {
    userName: '',
    garden: '',
    province: '',
    city: '',
    downtown: '',
    industry,
  };

  industryList: IndustryItem[] = [];

  loading = false;

  submit() {
    this.form.validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        try {
          const res = await updateBasicInfo({
            ...this.personalInfo,
            industry: this.personalInfo.industry.join(' '),
            garden: this.personalInfo.garden || 0,
          }) as { state: boolean; message: string };
          if (res.state) {
            this.$message.success('更新成功！');
            this.$emit('change');
          }
        } finally {
          this.loading = false;
        }
      }
    });
  }

  get province() {
    return this.personalInfo.province;
  }

  set province(val) {
    this.personalInfo.province = val;
  }

  get city() {
    return this.personalInfo.city;
  }

  set city(val) {
    this.personalInfo.city = val;
  }

  get downtown() {
    return this.personalInfo.downtown;
  }

  set downtown(val) {
    this.personalInfo.downtown = val;
  }

  get garden() {
    return this.personalInfo.garden;
  }

  set garden(val) {
    this.personalInfo.garden = val;
  }

  rules = {
    userName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
    downtown: [{ required: true, message: '请选择所在地区(区级)', trigger: 'blur' }],
    industry: [{
      required: true, message: '请选择技术领域', trigger: 'blur', type: 'array',
    }],
  };

  async getIndustryList() {
    const res = await getAllIndustry();
    if ((res as IndustryRes).state) {
      this.industryList = (res as IndustryRes).data.rows.map(item => ({
        id: String(item.id),
        name: item.name,
      }));
    }
  }

  mounted() {
    this.personalInfo = {
      ...this.value,
    };
    this.getIndustryList();
  }
}
